import React from 'react';
import { Row, Col } from 'antd';
import './styles.less';
import { WarningOutlined } from '@ant-design/icons';

const LegalRecordInfo = () => (
  <Row>
    <Col>
      <p className="previousStepForm__title--bold">Paso 1: Antecedentes Legales Requeridos</p>
      <p className="previousStepForm__subtitle">
        Para el contrato de clientes Persona Jurídica deberás cargar algunos documentos legales de
        la empresa que son requeridos para el estudio.
      </p>
      <p className="previousStepForm__subtitle--secondary">
        <WarningOutlined style={{ color: '#B22938' }} /> <strong>Nota:</strong> Puedes guardar tu
        proceso y completar este paso más adelante mientras buscas los antecedentes requeridos. Sin
        embargo, para finalizar el proceso y concretar la firma del contrato, deberás tener cargada
        toda la documentación.
      </p>
    </Col>
  </Row>
);

export default LegalRecordInfo;
